export const AUTH_CONFIG = {
  TOKEN_KEY: "app_access_token",
  REFRESH_TOKEN_KEY: "app_refresh_token",
  AUTH_COOKIE: "auth_session",
  ENDPOINTS: {
    AUTH: {
      LOGIN: "api/v1/web/authentication/login",
      LOGOUT: "api/v1/web/authentication/logout",
      REFRESH: "api/v1/web/authentication/refresh-token",
      REGISTER: "api/v1/web/authentication/register",
    },
  },
} as const;

export const API_CONFIG = {
  // BASE_URL: "https://localhost:5200",
  BASE_URL:
    import.meta.env.VITE_API_BASE_URL ||
    "https://codelinedevapi.azurewebsites.net",
  TIMEOUT: 30000,
  TEST_MODE: false,
} as const;
